const TermsOfService = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 sm:px-6 lg:px-8">
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-full sm:max-w-lg lg:max-w-2xl">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0A827D] mb-6 text-center">
          Conditions d'Utilisation
        </h1>
        <p className="text-gray-600 leading-relaxed mb-4">
          En utilisant notre application, vous acceptez que son utilisation est
          à vos propres risques. Nous ne collectons aucune donnée à des fins
          commerciales. Le contenu que vous envoyez via notre application reste
          sous votre responsabilité.
        </p>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous ne pouvons être tenus responsables des éventuelles erreurs,
          interruptions pouvant survenir lors de l'utilisation de notre service.
        </p>
        <p className="text-gray-600 leading-relaxed">
          Si vous avez des questions ou des préoccupations concernant nos
          conditions d'utilisation, veuillez nous contacter via notre formulaire
          ou à l'adresse email indiquée sur notre site.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
